import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import jsCookie from 'js-cookie'
import {
  getAppLocation,
  getCityCodeInNoGPSAuthorization,
  isEmptyObject,
  isHZWAPP,
  isNonEmptyArray,
  isNullOrEmpty,
  isRKHYAPP
} from '@/utils'
import { PREFIX_SCB_API } from '@/service'

/**
 * 根据商品spuId查询商家集合
 * @param {string | number} spuId
 * @param {{lng, lat, cityCode}} position
 * @typedef {Object} storeInfo
 * @property {number} businessKey
 * @property {string} addressCity
 * @property {string} addressDistrict
 * @property {string} addressProvince
 * @property {number} district -districID
 * @property {number} city - cityID
 * @property {number} province - provinceID
 * @property {string} distance
 * @property {string} distanceKm
 * @property {string} link
 * @property {number | string} latitude
 * @property {number | string} longitude
 * @property {string} mobile
 * @property {string} storeCategory
 * @property {number} storeId
 * @property {string} storeHeadImg
 * @property {string} storeImg
 * @property {string} storeName
 * @property {string} storeTime
 * @returns {Promise<storeInfo[]>}
 */
export async function queryStoreListBySpuId(spuId, position) {
  try {
    let url = `${PREFIX_SCB_API}appStore/queryStoreBySpuId.do?spuId=${spuId}`
    if (!isNullOrEmpty(position) && !isEmptyObject(position)) {
      url += `&longitude=${position.lng}&latitude=${position.lat}&city=${position.cityCode}`
    } else {
      // 用户禁止GPS授权 取手动定位的城市 取不到则取cookie.cityCode
      let cityCode = getCityCodeInNoGPSAuthorization()
      url += `&city=${cityCode}`
    }

    const res = await fetch(url)
    const j = await res.json()
    if (+j.code === 1) {
      let d = j.data || {}
      // 新接口
      if (isNonEmptyArray(d)) {
        return d
      }
      if (isNonEmptyArray(d.data)) return d.data
    }
    return []
  } catch (error) {
    throw error
  }
}
